import React from 'react'
import { Container } from '@mui/material'
import { ArrowForward, HeadsetMicOutlined, InfoOutlined, SlideshowOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import TopHeader from '../Components/TopHeader'
import Contacts from '../Components/Contact'
import TitrePage from './TitrePage'
import Reveal from '../Components/ui/Reveal'
import SectionHeader from '../Components/ui/SectionHeader'
import { Images } from '../Data/Images'

interface Props { }

function Contact(props: Props) {
    const { t, i18n } = useTranslation();
    const lang = i18n.language === 'fr' ? 0 : 1

    const Motifs: Array<any> = [
        {
            icon: <SlideshowOutlined />,
            link: "/contact",
            title: "Demander une démo|Request a demo",
            provider: "Découvrez le pouvoir de nos solutions. Demandez une démo dès aujourd'hui.|Discover the power of our solutions. Request a demo today."

        },
        {
            icon: <HeadsetMicOutlined />,
            link: "/contact",
            title: "Support client|Customer support",
            provider: "Nous sommes disponibles 24 heures sur 24 et 7 jours sur 7 pour répondre à vos questions et préoccupations.|We're available 24 hours a day, 7 days a week to answer your questions and address your concerns."

        },
        {
            icon: <InfoOutlined />,
            link: "/contact",
            title: "Demande de renseignements|Information request",
            provider: "Vous cherchez la bonne solution pour vos besoins en technologie bancaire ? Laissez notre équipe de vente vous guider.|Looking for the right solution for your banking technology needs? Let our sales team guide you."

        }
    ]

    const toForm = () => document.querySelector('#form')?.scrollIntoView({ behavior: 'smooth', block: 'start' })

    return (
        <div className="ibg-page">
            <TopHeader />
            <Header />
            <TitrePage image={Images.pageHeroes.contact.src} titre={'titrePage.contact.titre'} lien='contact' pageDescription={'titrePage.contact.description'} keyWords={'titrePage.contact.keywords'} />

            <section className="ibg-section">
                <Container maxWidth="lg">
                    <SectionHeader eyebrow={t("Contact.texte1")} title={t("Home.contactTitle")} />
                    <div className="ibg-grid ibg-grid--3">
                        {Motifs.map((f, index) => (
                            <Reveal key={f.title} delay={index * 0.08}>
                                <button className="ibg-tile" onClick={toForm}>
                                    <span className="ibg-tile__icon">{f.icon}</span>
                                    <h3 className="ibg-h4">{f.title.split("|")[lang]}</h3>
                                    <p className="ibg-small">{f.provider.split("|")[lang]}</p>
                                    <span className="ibg-tile__link">{t("contactUs")} <ArrowForward fontSize="small" /></span>
                                </button>
                            </Reveal>
                        ))}
                    </div>
                </Container>
            </section>

            <section id="form" className="ibg-section ibg-section--surface">
                <Container maxWidth="lg">
                    <SectionHeader eyebrow={t("Contact.texte2")} title={t("Label.Titre.titre1")} description={t("Contact.texte3")} />
                    <Contacts />
                </Container>
            </section>

            <Footer />
        </div>
    )
}

export default Contact
